export const BackgroundSVG = () => {
	return (
		<div className="hidden lg:pointer-events-none lg:relative lg:mx-auto lg:block lg:w-full lg:max-w-[1440px]">
			<svg
				className="absolute left-0 top-2.5 w-full max-w-[775px]"
				viewBox="0 0 775 669"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_3782_70716)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-491.085 -243L741.134 -243V-241.067L-491.085 -241.068V-243ZM-522 -210.61L-522 1021.61H-520.067L-520.067 -210.61H-522ZM-404.223 -123.289L-404.223 -7.44647H-491.085V-5.51389H-404.223L-404.223 110.329H-491.085V112.262H-404.223L-404.223 228.104H-491.085V230.037H-404.223L-404.223 345.878H-491.085V347.81H-404.223L-404.223 463.652H-491.085V465.585H-404.223V581.427H-491.085V583.36H-404.223L-404.223 699.195H-491.085V701.128H-404.223V816.968H-491.085V818.901H-404.223L-404.223 934.748H-491.085V936.681H-404.223V1021.61H-402.29V936.681H-286.446V1021.61H-284.513V936.681H-168.676V1021.61H-166.743V936.681H-50.9006V1021.61H-48.968V936.681H66.8723V1021.61H68.8049V936.681L184.649 936.681V1021.61H186.582V936.681H302.423V1021.61H304.356V936.681H420.196V1021.61H422.129V936.681H537.972V1021.61H539.905V936.681H655.75V1021.61H657.682V936.681H741.135V934.748H657.682L657.682 818.901H741.135V816.968H657.682V701.128H741.134V699.195H657.682V583.36H741.135V581.427H657.682V465.585H741.135V463.652H657.682V347.81H741.135V345.878H657.682V230.037H741.135V228.104H657.682V112.262H741.135V110.329H657.682V-5.51378H741.135V-7.44637H657.682V-123.289L741.135 -123.289V-125.222L657.682 -125.222V-210.608H655.75V-125.222L539.905 -125.222V-210.609H537.972V-125.222L422.129 -125.222V-210.609H420.196V-125.222L304.356 -125.222V-210.61H302.423V-125.222L186.582 -125.222V-210.61H184.649V-125.222L68.805 -125.222V-210.609H66.8724V-125.222L-48.9679 -125.222V-210.608H-50.9005V-125.222L-166.743 -125.222V-210.61H-168.676V-125.222L-284.513 -125.222V-210.61H-286.446V-125.222L-402.29 -125.222V-210.609H-404.223V-125.222L-491.085 -125.222V-123.289L-404.223 -123.289ZM-286.446 934.748H-402.29L-402.29 818.901H-286.446L-286.446 934.748ZM-168.676 934.748H-284.513L-284.513 818.901H-168.676L-168.676 934.748ZM-50.9006 934.748H-166.743L-166.743 818.901H-50.9005L-50.9006 934.748ZM66.8723 934.748H-48.968L-48.968 818.901H66.8724L66.8723 934.748ZM184.649 934.748L68.8049 934.748L68.805 818.901L184.649 818.901L184.649 934.748ZM302.423 934.748H186.582L186.582 818.901H302.423L302.423 934.748ZM420.196 934.748H304.356L304.356 818.901H420.196L420.196 934.748ZM537.972 934.748H422.129L422.129 818.901H537.972V934.748ZM655.75 934.748H539.905L539.905 818.901H655.75V934.748ZM655.75 816.968V701.128H539.905V816.968H655.75ZM537.972 816.968V701.128L422.129 701.128V816.968H537.972ZM420.196 816.968V701.128H304.356V816.968H420.196ZM302.423 816.968V701.128H186.582V816.968H302.423ZM184.649 816.968V701.128H68.805V816.968L184.649 816.968ZM66.8724 816.968V701.128H-48.968V816.968H66.8724ZM-50.9005 816.968V701.128H-166.743V816.968H-50.9005ZM-168.676 816.968V701.128L-284.513 701.128V816.968H-168.676ZM-286.446 816.968V701.128H-402.29V816.968H-286.446ZM-286.446 699.195H-402.29L-402.29 583.36H-286.446L-286.446 699.195ZM-168.676 699.195L-284.513 699.195L-284.513 583.36L-168.676 583.36L-168.676 699.195ZM-50.9005 699.195H-166.743L-166.743 583.36H-50.9005L-50.9005 699.195ZM66.8724 699.195H-48.968L-48.9679 583.36H66.8724V699.195ZM184.649 699.195H68.805V583.36H184.649V699.195ZM302.423 699.195H186.582V583.36H302.423V699.195ZM420.196 699.195H304.356V583.36H420.196V699.195ZM537.972 699.195L422.129 699.195V583.36L537.972 583.36V699.195ZM655.75 699.195H539.905V583.36H655.75V699.195ZM655.75 581.427V465.585H539.905V581.427H655.75ZM537.972 581.427V465.585L422.129 465.585V581.427L537.972 581.427ZM420.196 581.427V465.585H304.356V581.427H420.196ZM302.423 581.427V465.585H186.582V581.427H302.423ZM184.649 581.427V465.585H68.805V581.427H184.649ZM66.8724 581.427V465.585H-48.9679V581.427H66.8724ZM-50.9005 581.427V465.585H-166.743V581.427H-50.9005ZM-168.676 581.427V465.585L-284.513 465.585V581.427L-168.676 581.427ZM-286.446 581.427V465.585H-402.29V581.427H-286.446ZM-286.446 463.652H-402.29L-402.29 347.81H-286.446L-286.446 463.652ZM-168.676 463.652L-284.513 463.652L-284.513 347.81L-168.676 347.81V463.652ZM-50.9005 463.652H-166.743V347.81H-50.9005V463.652ZM66.8724 463.652H-48.9679V347.81H66.8724V463.652ZM184.649 463.652H68.805V347.81H184.649V463.652ZM302.423 463.652H186.582V347.81H302.423V463.652ZM420.196 463.652H304.356V347.81H420.196V463.652ZM537.972 463.652L422.129 463.652V347.81L537.972 347.81V463.652ZM655.75 463.652H539.905V347.81H655.75V463.652ZM655.75 345.878V230.037H539.905V345.878H655.75ZM537.972 345.878V230.037L422.129 230.037V345.878L537.972 345.878ZM420.196 345.878V230.037H304.356V345.878H420.196ZM302.423 345.878V230.037H186.582V345.878H302.423ZM184.649 345.878V230.037L68.805 230.037V345.878H184.649ZM66.8724 345.878V230.037H-48.9679V345.878H66.8724ZM-50.9005 345.878V230.037H-166.743V345.878H-50.9005ZM-168.676 345.878V230.037H-284.513V345.878L-168.676 345.878ZM-286.446 345.878V230.037H-402.29L-402.29 345.878H-286.446ZM-286.446 228.104L-402.29 228.104L-402.29 112.262H-286.446L-286.446 228.104ZM-168.676 228.104H-284.513V112.262H-168.676V228.104ZM-50.9005 228.104H-166.743V112.262H-50.9005V228.104ZM66.8724 228.104L-48.9679 228.104V112.262H66.8724V228.104ZM184.649 228.104H68.805V112.262L184.649 112.262V228.104ZM302.423 228.104L186.582 228.104V112.262H302.423V228.104ZM420.196 228.104H304.356V112.262H420.196V228.104ZM537.972 228.104H422.129V112.262L537.972 112.262V228.104ZM655.75 228.104L539.905 228.104V112.262H655.75V228.104ZM655.75 110.329V-5.51378L539.905 -5.51379V110.329L655.75 110.329ZM537.972 110.329V-5.51379L422.129 -5.51381V110.329H537.972ZM420.196 110.329V-5.51381H304.356V110.329H420.196ZM302.423 110.329V-5.51381L186.582 -5.51383V110.329L302.423 110.329ZM184.649 110.329V-5.51383L68.805 -5.51384V110.329H184.649ZM66.8724 110.329V-5.51384H-48.9679V110.329L66.8724 110.329ZM-50.9005 110.329V-5.51384L-166.743 -5.51386V110.329H-50.9005ZM-168.676 110.329V-5.51386L-284.513 -5.51387V110.329H-168.676ZM-286.446 110.329V-5.51387H-402.29L-402.29 110.329L-286.446 110.329ZM-286.446 -7.44646H-402.29L-402.29 -123.289L-286.446 -123.289V-7.44646ZM-168.676 -7.44644L-284.513 -7.44646V-123.289L-168.676 -123.289V-7.44644ZM-50.9005 -7.44643L-166.743 -7.44644V-123.289L-50.9005 -123.289V-7.44643ZM66.8724 -7.44643H-48.9679V-123.289L66.8724 -123.289V-7.44643ZM184.649 -7.44641L68.805 -7.44643V-123.289L184.649 -123.289V-7.44641ZM302.423 -7.4464L186.582 -7.44641V-123.289L302.423 -123.289V-7.4464ZM420.196 -7.4464H304.356V-123.289L420.196 -123.289V-7.4464ZM537.972 -7.44638L422.129 -7.4464V-123.289L537.972 -123.289V-7.44638ZM655.75 -7.44637L539.905 -7.44638V-123.289L655.75 -123.289V-7.44637ZM773.526 -210.608V1021.61L775.459 1021.61L775.459 -210.608H773.526ZM741.135 1052.52L-491.085 1052.52V1054.46L741.135 1054.46V1052.52Z"
						fill="url(#paint0_radial_3782_70716)"
						fillOpacity="0.05"
					/>
					<line
						x1="303.745"
						y1="78.9238"
						x2="303.745"
						y2="135.679"
						stroke="url(#paint1_linear_3782_70716)"
						strokeWidth="0.930416"
						opacity={1}
						transform-origin="0px 0px"
						style={{
							transform: 'translateY(-33.9914%)',
							transformOrigin: '0px 0px',
						}}
					/>
					<line
						x1="317.235"
						y1="464.58"
						x2="190.699"
						y2="464.58"
						stroke="url(#paint2_linear_3782_70716)"
						strokeWidth="0.930416"
						opacity={1}
						transform-origin="0px 0px"
						style={{
							transform: 'translateX(-40%)',
							transformOrigin: '0px 0px',
						}}
					/>
					<mask
						id="mask0_3782_70716"
						maskUnits="userSpaceOnUse"
						x={172}
						y={214}
						width={29}
						height={29}
					>
						<rect
							x={172}
							y={214}
							width={29}
							height={29}
							fill="#D9D9D9"
						/>
					</mask>
					<g mask="url(#mask0_3782_70716)">
						<path
							d="M185.655 229.334H179V228.486H185.655V222H186.526V228.486H193.181V229.334H186.526V235.82H185.655V229.334Z"
							fill="#414438"
							fillOpacity="0.8"
						/>
					</g>
				</g>
				<defs>
					<radialGradient
						id="paint0_radial_3782_70716"
						cx={0}
						cy={0}
						r={1}
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(83.7008 283.615) rotate(71.0092) scale(424.584 424.584)"
					>
						<stop />
						<stop offset={1} stopOpacity={0} />
					</radialGradient>
					<linearGradient
						id="paint1_linear_3782_70716"
						x1="303.105"
						y1="78.9238"
						x2="303.258"
						y2="127.305"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset="0.416667"
							stopColor="#4867FF"
							stopOpacity={0}
						/>
						<stop offset="0.895833" stopColor="#4867FF" />
						<stop offset={1} stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint2_linear_3782_70716"
						x1="317.235"
						y1="463.941"
						x2="209.372"
						y2="464.702"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset="0.416667"
							stopColor="#4867FF"
							stopOpacity={0}
						/>
						<stop offset="0.895833" stopColor="#4867FF" />
						<stop offset={1} stopColor="white" />
					</linearGradient>
					<clipPath id="clip0_3782_70716">
						<rect
							width={1297}
							height="911.405"
							fill="white"
							transform="translate(-522 -243)"
						/>
					</clipPath>
				</defs>
			</svg>
			<svg
				className="absolute right-0 top-2.5  w-full max-w-[728px]"
				viewBox="0 0 728 669"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_3782_70684)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-19.0855 -243L1213.13 -243V-241.067L-19.0855 -241.067V-243ZM656.649 -125.222V-210.61H658.582V-125.222L774.423 -125.222V-210.61H776.356V-125.222L892.196 -125.222V-210.609H894.129V-125.222L1009.97 -125.222V-210.609H1011.91V-125.222L1127.75 -125.222V-210.609H1129.68V-125.222L1213.13 -125.222V-123.289L1129.68 -123.289V-7.44685H1213.13V-5.51425L1129.68 -5.51427V110.329H1213.13V112.261H1129.68V228.104H1213.13V230.036H1129.68V345.878H1213.13V347.811H1129.68V463.652H1213.13V465.585H1129.68V581.427H1213.13V583.359H1129.68V699.195H1213.13V701.128H1129.68V816.97H1213.13V818.902H1129.68L1129.68 934.75H1213.13V936.682H1129.68V1021.61H1127.75V936.682H1011.91V1021.61H1009.97V936.682H894.129V1021.61H892.196V936.682H776.356V1021.61H774.423V936.682H658.582V1021.61H656.649V936.682L540.805 936.682V1021.61H538.872V936.682H423.032V1021.61H421.099V936.682H305.257V1021.61H303.324V936.682H187.487V1021.61H185.554V936.682H69.7101V1021.61H67.7775V936.682H-19.0848V934.75H67.7775L67.7775 818.902H-19.0848V816.969H67.7775V701.128H-19.0856V699.195H67.7775L67.7775 583.359H-19.0848V581.427H67.7775V465.584H-19.0848V463.652H67.7775L67.7775 347.811H-19.0848V345.878H67.7775L67.7775 230.036H-19.0848V228.104H67.7775L67.7775 112.261H-19.0848V110.329H67.7775L67.7775 -5.51436L-19.0848 -5.51437V-7.44696H67.7775L67.7775 -123.289L-19.0848 -123.289V-125.222L67.7775 -125.222V-210.61H69.7101V-125.222L185.554 -125.222V-210.61H187.487V-125.222L303.324 -125.222V-210.61H305.257V-125.222L421.099 -125.222V-210.609H423.032V-125.222L538.872 -125.222V-210.609H540.805V-125.222L656.649 -125.222ZM1127.75 818.902V934.75H1011.91L1011.91 818.902H1127.75ZM1009.97 818.902V934.75H894.129L894.129 818.902H1009.97ZM892.196 818.902L892.196 934.75H776.356L776.356 818.902H892.196ZM774.423 818.902L774.423 934.75H658.582L658.582 818.902H774.423ZM656.649 818.902L656.649 934.75L540.805 934.75L540.805 818.902L656.649 818.902ZM538.872 818.902L538.872 934.75H423.032L423.032 818.902H538.872ZM421.099 818.902L421.099 934.75H305.257L305.257 818.902H421.099ZM303.324 818.902L303.324 934.75H187.487L187.487 818.902H303.324ZM185.554 818.902L185.554 934.75H69.7101L69.7101 818.902H185.554ZM69.7101 816.969H185.554V701.128H69.7101V816.969ZM187.487 816.969H303.324V701.128L187.487 701.128V816.969ZM305.257 816.969H421.099V701.128H305.257V816.969ZM423.032 816.969H538.872V701.128H423.032V816.969ZM540.805 816.969L656.649 816.97V701.128H540.805V816.969ZM658.582 816.97H774.423V701.128H658.582V816.97ZM776.356 816.97H892.196V701.128H776.356V816.97ZM894.129 816.97H1009.97V701.128L894.129 701.128V816.97ZM1011.91 816.97H1127.75V701.128H1011.91V816.97ZM1127.75 583.359V699.195H1011.91V583.359H1127.75ZM1009.97 583.359V699.195L894.129 699.195V583.359L1009.97 583.359ZM892.196 583.359V699.195H776.356V583.359H892.196ZM774.423 583.359V699.195H658.582V583.359H774.423ZM656.649 583.359V699.195H540.805V583.359H656.649ZM538.872 583.359V699.195H423.032L423.032 583.359H538.872ZM421.099 583.359L421.099 699.195H305.257L305.257 583.359H421.099ZM303.324 583.359L303.324 699.195L187.487 699.195L187.487 583.359L303.324 583.359ZM185.554 583.359L185.554 699.195H69.7101L69.7101 583.359H185.554ZM69.7101 581.427H185.554V465.584H69.7101V581.427ZM187.487 581.427L303.324 581.427V465.585L187.487 465.584V581.427ZM305.257 581.427H421.099V465.585H305.257V581.427ZM423.032 581.427H538.872V465.585H423.032V581.427ZM540.805 581.427H656.649V465.585H540.805V581.427ZM658.582 581.427H774.423V465.585H658.582V581.427ZM776.356 581.427H892.196V465.585H776.356V581.427ZM894.129 581.427L1009.97 581.427V465.585L894.129 465.585V581.427ZM1011.91 581.427H1127.75V465.585H1011.91V581.427ZM1127.75 347.811V463.652H1011.91V347.811H1127.75ZM1009.97 347.811V463.652L894.129 463.652V347.811L1009.97 347.811ZM892.196 347.811V463.652H776.356V347.811H892.196ZM774.423 347.811V463.652H658.582V347.811H774.423ZM656.649 347.811V463.652H540.805V347.811H656.649ZM538.872 347.811V463.652H423.032V347.811H538.872ZM421.099 347.811V463.652H305.257V347.811H421.099ZM303.324 347.811V463.652L187.487 463.652L187.487 347.811L303.324 347.811ZM185.554 347.811L185.554 463.652H69.7101L69.7101 347.811H185.554ZM69.7101 345.878H185.554V230.036H69.7101L69.7101 345.878ZM187.487 345.878L303.324 345.878V230.036H187.487V345.878ZM305.257 345.878H421.099V230.036H305.257V345.878ZM423.032 345.878H538.872V230.036H423.032V345.878ZM540.805 345.878H656.649V230.036L540.805 230.036V345.878ZM658.582 345.878H774.423V230.036H658.582V345.878ZM776.356 345.878H892.196V230.036H776.356V345.878ZM894.129 345.878L1009.97 345.878V230.036L894.129 230.036V345.878ZM1011.91 345.878H1127.75V230.036H1011.91V345.878ZM1127.75 112.261V228.104L1011.91 228.104V112.261H1127.75ZM1009.97 112.261V228.104H894.129V112.261L1009.97 112.261ZM892.196 112.261V228.104H776.356V112.261H892.196ZM774.423 112.261V228.104L658.582 228.104V112.261H774.423ZM656.649 112.261V228.104H540.805V112.261L656.649 112.261ZM538.872 112.261V228.104L423.032 228.104V112.261H538.872ZM421.099 112.261V228.104H305.257V112.261H421.099ZM303.324 112.261V228.104H187.487L187.487 112.261H303.324ZM185.554 112.261L185.554 228.104L69.7101 228.104L69.7101 112.261H185.554ZM69.7101 110.329L185.554 110.329V-5.51436H69.7101L69.7101 110.329ZM187.487 110.329H303.324V-5.51434L187.487 -5.51436V110.329ZM305.257 110.329H421.099V-5.51433L305.257 -5.51434V110.329ZM423.032 110.329L538.872 110.329V-5.51431L423.032 -5.51433V110.329ZM540.805 110.329H656.649V-5.51431H540.805V110.329ZM658.582 110.329L774.423 110.329V-5.5143L658.582 -5.51431V110.329ZM776.356 110.329H892.196V-5.51428L776.356 -5.5143V110.329ZM894.129 110.329H1009.97V-5.51427L894.129 -5.51428V110.329ZM1011.91 110.329L1127.75 110.329V-5.51427H1011.91V110.329ZM1127.75 -123.289V-7.44685L1011.91 -7.44687V-123.289L1127.75 -123.289ZM1009.97 -123.289V-7.44687L894.129 -7.44688V-123.289L1009.97 -123.289ZM892.196 -123.289V-7.44688H776.356V-123.289L892.196 -123.289ZM774.423 -123.289V-7.44688L658.582 -7.4469V-123.289L774.423 -123.289ZM656.649 -123.289V-7.4469L540.805 -7.44691V-123.289L656.649 -123.289ZM538.872 -123.289V-7.44691H423.032V-123.289L538.872 -123.289ZM421.099 -123.289V-7.44691L305.257 -7.44693V-123.289L421.099 -123.289ZM303.324 -123.289V-7.44693L187.487 -7.44695V-123.289L303.324 -123.289ZM185.554 -123.289V-7.44695H69.7101L69.7101 -123.289L185.554 -123.289ZM-49.9999 -210.61L-50 1021.61H-48.0674L-48.0674 -210.61H-49.9999ZM1245.53 -210.609V1021.61H1247.46L1247.46 -210.609H1245.53ZM1213.13 1052.53L-19.0848 1052.53V1054.46L1213.13 1054.46V1052.53Z"
						fill="url(#paint0_radial_3782_70684)"
						fillOpacity="0.05"
					/>
					<line
						x1="539.965"
						y1={47}
						x2="539.965"
						y2="121.433"
						stroke="url(#paint1_linear_3782_70684)"
						strokeWidth="0.930416"
						opacity={1}
						transform-origin="0px 0px"
						style={{
							transform: 'translateY(67.9874%)',
							transformOrigin: '0px 0px',
						}}
					/>
					<line
						x1="839.735"
						y1="464.581"
						x2="713.199"
						y2="464.581"
						stroke="url(#paint2_linear_3782_70684)"
						strokeWidth="0.930416"
					/>
					<mask
						id="mask0_3782_70684"
						maskUnits="userSpaceOnUse"
						x={526}
						y={332}
						width={29}
						height={29}
					>
						<rect
							x={526}
							y={332}
							width={29}
							height={29}
							fill="#D9D9D9"
						/>
					</mask>
					<g mask="url(#mask0_3782_70684)">
						<path
							d="M539.655 347.334H533V346.486H539.655V340H540.526V346.486H547.181V347.334H540.526V353.82H539.655V347.334Z"
							fill="#414438"
							fillOpacity="0.8"
						/>
					</g>
				</g>
				<defs>
					<radialGradient
						id="paint0_radial_3782_70684"
						cx={0}
						cy={0}
						r={1}
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(555.701 283.616) rotate(71.0092) scale(424.584 424.584)"
					>
						<stop />
						<stop offset={1} stopOpacity={0} />
					</radialGradient>
					<linearGradient
						id="paint1_linear_3782_70684"
						x1="539.326"
						y1={47}
						x2="539.589"
						y2="110.451"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset="0.416667"
							stopColor="#4867FF"
							stopOpacity={0}
						/>
						<stop offset="0.895833" stopColor="#4867FF" />
						<stop offset={1} stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint2_linear_3782_70684"
						x1="839.735"
						y1="463.942"
						x2="731.872"
						y2="464.703"
						gradientUnits="userSpaceOnUse"
					>
						<stop
							offset="0.416667"
							stopColor="#4867FF"
							stopOpacity={0}
						/>
						<stop offset="0.895833" stopColor="#4867FF" />
						<stop offset={1} stopColor="white" />
					</linearGradient>
					<clipPath id="clip0_3782_70684">
						<rect
							width={1297}
							height="911.405"
							fill="white"
							transform="translate(0.5 -243)"
						/>
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};
